import * as css from './SendToEmail.css';
import {useTranslation} from 'react-i18next';
import {useField, useFormikContext} from 'formik';

function SendToEmail({onClick=()=>{},disabled}) {
    const {t}=useTranslation('login');

    const {submitForm} = useFormikContext();
    const [,,helper]=useField('sendToEmail');

    const sendToEmail=()=> {
        if(disabled) {
            return;
        }
        helper.setValue(true);
        submitForm().then(onClick);
    };
    
    return (
        <css.toEmail 
            id="emailIcon" 
            disabled={disabled}
            onClick={sendToEmail} 
            data-cy='emailCodeLogin'
            className={disabled ? 'disabled' : ''}
        >
            <css.icon/>
            <span> {t('sendMeEmail')}</span>
        </css.toEmail>
        
    );
}

export default SendToEmail;